import { ReactElement, useState, useCallback } from 'react';

import { useAppSelector, useTypePartnerCompany } from '~hooks/index';
import { selectAuth } from '~store/slices/auth/index';
import { selectHome } from '~store/slices/home/index';
import { getOcurrencesDataCompany } from '~utils/home';
import { isAdminUser } from '~utils/user';
import { InitialSetupWizard } from '~components/index';

import { DashboardCompleteInitialConfigWrapperProps } from './types';

const DashboardCompleteInitialConfigWrapper = ({
  vehiclesCount,
  warehousesCount,
  onComplete,
  children,
}: DashboardCompleteInitialConfigWrapperProps): ReactElement => {
  const { user } = useAppSelector(selectAuth);
  const { skipInitialConfig } = useAppSelector(selectHome);
  const { isCarrier } = useTypePartnerCompany();

  const [enabledConfigPanel, setEnabledConfigPanel] = useState(() => {
    const ocurrencesDataCompany = getOcurrencesDataCompany(
      isCarrier ? vehiclesCount : 1, // Skip the vehicles count to giver companies
      warehousesCount,
      1, // Skip the drivers count
    );

    return isAdminUser(user) && !skipInitialConfig && ocurrencesDataCompany < 3;
  });

  const handleClose = useCallback(() => {
    setEnabledConfigPanel(false);
    onComplete();
  }, [onComplete]);

  if (enabledConfigPanel) {
    return <InitialSetupWizard onClose={handleClose} />;
  }

  return children;
};

export default DashboardCompleteInitialConfigWrapper;
